import { Component, input, output, signal, viewChild } from '@angular/core';
import { ProduktAttribute } from '@mwe/models';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-tariff-selection-card-collapse-item',
  templateUrl: './tariff-selection-card-collapse-item.component.html',
  imports: [NgClass, NgbCollapse, TranslatePipe],
})
export class TariffSelectionCardCollapseItemComponent {
  item = input<ProduktAttribute>();
  collapseToggleClicked = output();
  isCollapsed = signal(true);

  private collapseRef = viewChild<NgbCollapse>('collapse');

  collapse(): void {
    this.isCollapsed.set(true);
    this.collapseRef().collapsed = true;
  }

  // accordion - close other collapse-items
  toggleCollapse() {
    const openMe = this.isCollapsed();
    this.collapseToggleClicked.emit();
    if (openMe) {
      this.isCollapsed.set(false);
      this.collapseRef().collapsed = false;
    }
  }
}
